import PropTypes from 'prop-types';

import { RatePropType } from './rate';

/** @typedef {import('./rate').RatePropType} RatePropType */

export const RateBrowserRatePropType = PropTypes.shape({
  serviceId: PropTypes.string,
  shipDate: PropTypes.string,
  rateName: PropTypes.string,
  rate: RatePropType,
});

/**
 * @typedef {object} RateBrowserRatePropType
 * @property {string} serviceId
 * @property {string} shipDate
 * @property {string} rateName
 * @property {RatePropType} rate
 */
